<!-- <nb-layout windowMode>
    <nb-sidebar class="settings-sidebar expanded" tag="right" right>
        <p>Ma se poes</p>
    </nb-sidebar>
    <nb-layout-column style="margin-top: 3rem;">
        <ng-template cms-host [activeComponent]="activeComponent"></ng-template>
    </nb-layout-column>
</nb-layout> -->
<p>what gaan aan - oes</p>

